var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('div',{staticClass:"hotel-building-room-add-view"},[_c('h1',{staticClass:"app-h1"},[_vm._v(" Новый номер ")]),_c('hotel-building-room-form',{attrs:{"building-id":_vm.buildingId,"hotel-id":_vm.hotelId}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }